import { BopsLogo } from '@Assets';

const MotifMark = () => (
  <div className="w-24 h-24 rounded-full bg-white border border-gray-200 shadow-[0_0_20px_rgba(124,108,246,0.35)] flex items-center justify-center">
    <BopsLogo className="h-12" />
  </div>
);

export default MotifMark;
